import { useHttpClient, type SuccessResponse } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { InboundDeliveryResponse } from './common/inboundDeliveryResponse';

interface InboundDeliveryQueryRequest {
  from: string;
  to: string;
}

export interface ListInboundDeliveryResponse extends SuccessResponse {
  deliveries: InboundDeliveryResponse[];
}

export function useListInboundDeliveryQueryApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  async function execute(requestBody: InboundDeliveryQueryRequest) {
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('delivery/inbound/query'), {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody),
    });

    const text = translations.value.inboundDelivery.actions.fetchMany;

    const response = await httpClient.action<ListInboundDeliveryResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: async (r) => {
        const data = (await r.json()) as { deliveries: InboundDeliveryResponse[] };
        return {
          ok: true,
          deliveries: data.deliveries,
        };
      },
    });

    return response;
  }

  return {
    execute,
  };
}
